import React, { useEffect, useState } from 'react'
import { AllObjectTypeComponent } from '../Components/ObjectType/AllObjectTypeComponent';
import { AllObjectInstanceComponent } from '../Components/ObjectInstance/AllObjectInstanceComponent';
import { GetById_ObjectType_Api } from '../API/objectTypeApi';
import { AddObjectInstanceComponent } from '../Components/ObjectInstance/AddObjectInstanceComponent';
import { EditObjectInstanceComponent } from '../Components/ObjectInstance/EditObjectInstanceComponent';
import { EditObjectFieldValueComponent } from '../Components/ObjectInstance/EditObjectFieldValueComponent';
import { EditObjectInstanceCategoryComponent } from '../Components/ObjectInstance/EditObjectInstanceCategoryComponent';
//import { ObjectOutOfServiceComponent } from '../Components/ObjectOutOfService/ObjectOutOfServiceComponent';
import { AllObjectOutOfServiceComponent } from "../Components/ObjectOutOfService/AllObjectOutOfServiceComponent";
import { AddObjectOutOfServiceComponent } from "../Components/ObjectOutOfService/AddObjectOutOfServiceComponent";
import { EditObjectOutOfServiceComponent } from "../Components/ObjectOutOfService/EditObjectOutOfServiceComponent";
// ======================================================================
export const ObjectInstance = ({ setLoading, showMessage }) => {
    // ======================================================================
    const [view, setView] = useState('ObjectTypes');
    const [currentPageObjectTypes, setCurrentPageObjectTypes] = useState(1);
    const [version, setVersion] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [objectInstanceId, setObjectInstanceId] = useState(0);
    const [objectTypeId, setObjectTypeId] = useState(0);
    const [objectType, setObjectType] = useState();
    const [objectOutOfServiceObjectId, setObjectOutOfServiceObjectId] = useState(0);
    const [objectOutOfServiceId, setObjectOutOfServiceId] = useState(0);
const [objectInstanceTitle, setObjectInstanceTitle] = useState("");
    // ======================================================================
    useEffect(() => {
        loadObjectType();
    }, [objectTypeId]);
    // =================================================================
    const loadObjectType = async () => {
        setLoading(true);
        try {
            const data = await GetById_ObjectType_Api(objectTypeId);
            setLoading(false);
            if (data.messageStatus == "Successful")
                setObjectType(data.messageData.data);
        }
        catch (error) {
            setLoading(false);
        }
    }
    // =================================================================
    return (
        <>
            {view == "ObjectTypes" ?
                <AllObjectTypeComponent
                    setLoading={setLoading}
                    showMessage={showMessage}
                    version={version}
                    currentPage={currentPageObjectTypes}
                    setCurrentPage={setCurrentPageObjectTypes}
                    isShowInsert={false}
                    isShowEdit={false}
                    isShowDelete={false}
                    onClickItem={(id) => { setObjectTypeId(id); setView("ObjectInstances"); }}
                />
                : <></>
            }
            {view == "ObjectInstances" ?
                <>
                    <AllObjectInstanceComponent
                        objectTypeId={objectTypeId}
                        objectTypeTitle={objectType?.title}
                        setLoading={setLoading}
                        showMessage={showMessage}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        version={version}
                        onAddClick={() => setView("Add")}
                        onEdit={(id) => { setObjectInstanceId(id); setView("Edit"); }}
                        onRowDeleted={() => { setVersion(version + 1); }}
                        onSetObjectFieldValues={(id) => { setObjectInstanceId(id); setView("ObjectFieldValues") }}
                        onCategoryClick={(id) => { setObjectInstanceId(id); setView("ObjectCategory") }}
                        onOutOfServiceClick={(id,title)=>{
    setObjectInstanceId(id);
    setObjectInstanceTitle(title);
    setView("ObjectOutOfService");
}}
onOutOfService={(id,title)=>{
    setObjectInstanceId(id);
    setObjectInstanceTitle(title);
    setView("ObjectOutOfService");
}}
                        onBackClick={() => { setView("ObjectTypes") }}
                    />
                </> : <></>
            }
            {view === "Add" ?
                <AddObjectInstanceComponent
                    objectTypeId={objectTypeId}
                    setLoading={setLoading}
                    showMessage={showMessage}
                    rowInserted={() => {
                        setView("ObjectInstances"); if (currentPage != 1)
                            setCurrentPage(1);
                        else
                            setVersion(version + 1);
                    }}
                    cancelInsert={() => { setView("ObjectInstances"); }} /> : <></>
            }
            {view === "Edit" ?
                <EditObjectInstanceComponent
                    setLoading={setLoading}
                    showMessage={showMessage}
                    id={objectInstanceId}
                    objectTypeId={objectTypeId}
                    rowUpdated={() => { setView("ObjectInstances"); setVersion(version + 1); }}
                    cancelEdit={() => { setView("ObjectInstances"); }} /> : <></>
            }
            {view == "ObjectCategory" ?
                <EditObjectInstanceCategoryComponent
                    setLoading={setLoading}
                    showMessage={showMessage}
                    objectInstanceId={objectInstanceId}
                    onBackClick={() => { setView("ObjectInstances"); }}
                /> : <></>
            }
            {view == "ObjectFieldValues" ?
                <EditObjectFieldValueComponent
                    objectTypeId={objectTypeId}
                    objectInstanceId={objectInstanceId}
                    setLoading={setLoading}
                    showMessage={showMessage}
                    onCompleteEdit={() => { setView("ObjectInstances"); }}
                /> : <></>
            }
            {
view==="ObjectOutOfService" &&

<AllObjectOutOfServiceComponent

    objectInstanceId={objectInstanceId}

    objectTitle={objectInstanceTitle}

    setLoading={setLoading}

    showMessage={showMessage}

    onBackClick={()=>{
        setView("ObjectInstances");
    }}

    onAddClick={()=>{
        setView("AddObjectOutOfService");
    }}

    onEditClick={(id)=>{
        setObjectOutOfServiceId(id);
        setView("EditObjectOutOfService");
    }}
    
    
/>
}
{
view==="AddObjectOutOfService" &&

<AddObjectOutOfServiceComponent

    objectInstanceId={objectInstanceId}
    objectInstanceTitle={objectInstanceTitle}  // ✅ اضافه کنید

reasonParentId = {7395}
    setLoading={setLoading}

    showMessage={showMessage}

    onSaved={()=>{
        setView("ObjectOutOfService");
    }}

    onCancel={()=>{
        setView("ObjectOutOfService");
    }}
    cancelInsert={() => setView("ObjectOutOfService")}  // ✅ اضافه کنید

/>
}
{
view==="EditObjectOutOfService" &&

<EditObjectOutOfServiceComponent

    id={objectOutOfServiceId}

    objectInstanceId={objectInstanceId}
    objectInstanceTitle={objectInstanceTitle}  // ✅ اضافه کنید
    reasonParentId = {7395}

    setLoading={setLoading}

    showMessage={showMessage}

    onSaved={()=>{
        setView("ObjectOutOfService");
    }}

    onCancel={()=>{
        setView("ObjectOutOfService");
    }}
    cancelEdit={() => setView("ObjectOutOfService")}  // ✅ اضافه کنید

/>
}
        </>
    )
}
